<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'PageNotFound',
  data () {
    return {
      title: null,
      description: null
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/404.vue